<template>
    <div class="hv-preview" v-loading="loading">
        <div v-if="data && data.header" class="hv-preview-body">
            <div class="hv-preview-title">
                <span>{{ data.header.title || ((data.header.customer_name || '') + ' · 智能客户洞察') }}</span>
                <el-tag size="mini" type="warning">AI</el-tag>
            </div>

            <div class="hv-block">
                <div class="hv-block-title">
                    <span class="hv-block-title-left"><i class="el-icon-office-building"></i><em>客户概览</em></span>
                </div>
                <table class="hv-table">
                    <tr>
                        <th>客户名称</th>
                        <td>{{ fieldText(data.overview, 'name') }}</td>
                        <th>统一社会信用代码</th>
                        <td>{{ fieldText(data.overview, 'credit_code') }}</td>
                    </tr>
                    <tr>
                        <th>法人姓名</th>
                        <td><span>{{ fieldText(data.overview, 'legal_person') }}</span><el-tag v-if="fieldAi(data.overview, 'legal_person')" size="mini" type="warning" class="ai-tag">AI</el-tag></td>
                        <th>电话</th>
                        <td><span>{{ fieldText(data.overview, 'phone') }}</span><el-tag v-if="fieldAi(data.overview, 'phone')" size="mini" type="warning" class="ai-tag">AI</el-tag></td>
                    </tr>
                    <tr>
                        <th>所在地区</th>
                        <td>{{ fieldText(data.overview, 'region') }}</td>
                        <th>学段</th>
                        <td>{{ fieldText(data.overview, 'stage') }}</td>
                    </tr>
                    <tr>
                        <th>办学性质</th>
                        <td>{{ fieldText(data.overview, 'school_type') }}</td>
                        <th>客户类型</th>
                        <td>{{ fieldText(data.overview, 'customer_type') }}</td>
                    </tr>
                    <tr>
                        <th>详细地址</th>
                        <td><span>{{ fieldText(data.overview, 'address') }}</span><el-tag v-if="fieldAi(data.overview, 'address')" size="mini" type="warning" class="ai-tag">AI</el-tag></td>
                        <th>客户级别</th>
                        <td>{{ fieldText(data.overview, 'level') }}</td>
                    </tr>
                    <tr>
                        <th>学生数</th>
                        <td><span>{{ fieldText(data.overview, 'student_num') }}</span><el-tag v-if="fieldAi(data.overview, 'student_num')" size="mini" type="warning" class="ai-tag">AI</el-tag></td>
                        <th>班级数</th>
                        <td><span>{{ fieldText(data.overview, 'class_num') }}</span><el-tag v-if="fieldAi(data.overview, 'class_num')" size="mini" type="warning" class="ai-tag">AI</el-tag></td>
                    </tr>
                    <tr>
                        <th>教师数</th>
                        <td><span>{{ fieldText(data.overview, 'teacher_num') }}</span><el-tag v-if="fieldAi(data.overview, 'teacher_num')" size="mini" type="warning" class="ai-tag">AI</el-tag></td>
                        <th>最后跟进时间</th>
                        <td>{{ fieldText(data.overview, 'last_trace_at') }}</td>
                    </tr>
                </table>
            </div>

            <div class="hv-block">
                <div class="hv-block-title">
                    <span class="hv-block-title-left"><i class="el-icon-user"></i><em>对接人与决策链</em></span>
                    <el-tag size="mini" type="warning">AI</el-tag>
                </div>
                <div v-if="contacts.length" class="contact-list">
                    <div v-for="item in contacts" :key="item.id" class="contact-card" :class="'role-' + item.role">
                        <div class="contact-head">
                            <span class="contact-name">{{ item.name || '—' }}</span>
                            <el-tag v-if="item.name_ai" size="mini" type="warning">AI</el-tag>
                            <el-tag size="mini" class="role-tag">{{ item.role_name }}</el-tag>
                        </div>
                        <div class="contact-job">{{ item.job_name || '—' }}</div>
                        <div class="contact-mobile">{{ item.mobile_masked || '暂无手机号' }}</div>
                        <div class="contact-meta">
                            <span>{{ applyText(item.apply_products) }}</span>
                            <span>{{ item.created_at || '—' }}</span>
                        </div>
                        <div class="contact-foot">
                            <span>当前态度：{{ item.attitude || '—' }}</span>
                            <span>已联系：{{ item.contact_count || 0 }}次</span>
                        </div>
                    </div>
                </div>
                <div v-else class="empty-text">暂无对接人</div>
            </div>

            <div class="hv-block">
                <div class="hv-block-title">
                    <span class="hv-block-title-left"><i class="el-icon-location-outline"></i><em>周边客户成交情况</em><el-button type="text" @click="openDone">成交客户</el-button></span>
                </div>
                <div v-if="nearby.city_name && (nearbyDistricts.length || nearbyProducts.length)" class="nearby-panels">
                    <div v-if="nearbyDistricts.length" class="nearby-panel">
                        <div class="nearby-panel-head">{{ nearby.city_name }}成交客户{{ nearby.total || 0 }}个</div>
                        <div class="nearby-panel-body">
                            <div v-for="item in nearbyDistricts" :key="item.district_id || item.district_name" class="nearby-panel-row">
                                <em>{{ item.district_name || '未知' }}</em>
                                <span>{{ item.customer_count || 0 }}个</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="nearbyProducts.length" class="nearby-panel">
                        <div class="nearby-panel-head">已购产品{{ nearbyProducts.length }}种</div>
                        <div class="nearby-panel-body">
                            <div v-for="item in nearbyProducts" :key="item.product_id || item.product_name" class="nearby-panel-row">
                                <em>{{ item.product_name || '未知' }}</em>
                                <span>{{ item.customer_count || 0 }}个客户</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="empty-text">{{ nearby.summary_text || '暂无同城成交数据' }}</div>
                <div class="sub-title"><span class="sub-ico">🏆</span>名校成交信息</div>
                <div v-if="famousSchools.length" class="famous-list">
                    <div v-for="(school, index) in famousSchools" :key="index" class="famous-card">
                        <div class="famous-head">
                            <span v-for="tag in school.tags" :key="tag" class="school-tag" :class="famousTagClass(tag)">{{ tag }}</span>
                            <strong class="famous-name" :title="school.customer_name">{{ school.customer_name }}</strong>
                            <span class="product-tag" :class="productTagClass(index)">{{ school.product_name }}</span>
                        </div>
                        <div class="famous-line"><i class="el-icon-location-outline"></i> {{ school.region || '—' }}</div>
                        <div class="famous-line"><i class="el-icon-menu"></i> 班级数：{{ school.class_num || '—' }}</div>
                        <div class="famous-line"><i class="el-icon-date"></i> 合同时间：{{ school.contract_start || '—' }}至{{ school.contract_end || '—' }}</div>
                        <div class="famous-line"><i class="el-icon-time"></i> 最后成交：{{ school.last_deal_at || '—' }}</div>
                    </div>
                </div>
                <div v-else class="empty-text">暂无名校成交信息</div>
            </div>

            <div class="preview-footer">
                <el-button type="text" @click="$emit('open-full')">查看完整智能洞察</el-button>
            </div>
        </div>
        <div v-else-if="!loading" class="empty-text">暂无洞察预览</div>
    </div>
</template>

<script>
export default {
    name: "HighValueInsightPreview",
    props: {
        data: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        contacts() {
            return (this.data && this.data.contacts) ? this.data.contacts : [];
        },
        nearby() {
            return (this.data && this.data.nearby) ? this.data.nearby : {};
        },
        famousSchools() {
            return this.nearby.famous_schools || [];
        },
        nearbyDistricts() {
            return this.nearby.districts || [];
        },
        nearbyProducts() {
            return this.nearby.products || [];
        }
    },
    methods: {
        fieldText(overview, key) {
            if (!overview || !overview[key]) {
                return '—';
            }
            const value = overview[key].value;
            return value === null || value === '' ? '—' : value;
        },
        fieldAi(overview, key) {
            return !!(overview && overview[key] && overview[key].ai);
        },
        applyText(list) {
            if (!list || !list.length) {
                return '暂无意向产品';
            }
            return list.map(function (item) {
                return item.product_name;
            }).join('、');
        },
        famousTagClass(tag) {
            const t = String(tag || '');
            if (t.indexOf('市重点') >= 0) return 'tag-city';
            if (t.indexOf('区重点') >= 0 || t.indexOf('省重点') >= 0) return 'tag-district';
            return 'tag-school';
        },
        productTagClass(index) {
            return ['tag-prod-blue', 'tag-prod-cyan', 'tag-prod-green'][index % 3];
        },
        openDone() {
            const data = this.nearby || {};
            const query = {};
            if (data.province_id) {
                query.province_id = data.province_id;
            }
            if (data.city_id) {
                query.city_id = data.city_id;
            }
            const route = this.$router.resolve({
                path: '/customers/done',
                query: query
            });
            window.open(route.href, '_blank');
        }
    }
}
</script>

<style scoped>
.hv-preview {
    max-height: calc(100vh - 150px);
    overflow: auto;
    min-width: 0;
}
.hv-preview-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
}
.hv-block {
    margin-bottom: 16px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    padding: 12px;
}
.hv-block-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #303133;
}
.hv-block-title-left {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex: 0 0 auto;
}
.hv-block-title-left i {
    margin: 0;
    flex: 0 0 auto;
}
.hv-block-title-left em {
    font-style: normal;
    margin: 0;
    white-space: nowrap;
}
.hv-block-title > .el-tag {
    margin-left: 0;
}
.hv-block-title-left > .el-button {
    margin-left: 0;
    padding: 0;
}
.hv-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
}
.hv-table th,
.hv-table td {
    border: 1px solid #ebeef5;
    padding: 8px;
}
.hv-table th {
    width: 110px;
    background: #f5f7fa;
    color: #909399;
    font-weight: 500;
}
.ai-tag {
    margin-left: 6px;
}
.contact-list,
.famous-list {
    display: flex;
    gap: 10px;
    overflow-x: auto;
}
.contact-card,
.famous-card {
    min-width: 210px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 10px;
    background: #fff;
}
.role-decision { border-top: 3px solid #f56c6c; }
.role-influencer { border-top: 3px solid #e6a23c; }
.role-executor { border-top: 3px solid #67c23a; }
.contact-head,
.famous-head {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
}
.contact-name,
.famous-name {
    font-weight: 600;
}
.contact-job,
.contact-mobile,
.contact-meta,
.contact-foot,
.famous-line {
    color: #606266;
    font-size: 12px;
    line-height: 1.6;
}
.nearby-panels {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 12px;
}
.nearby-panel {
    border: 1px solid #dbeafe;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
}
.nearby-panel-head {
    background: #e8f3ff;
    color: #2563eb;
    font-size: 13px;
    font-weight: 600;
    padding: 10px 12px;
}
.nearby-panel-body {
    max-height: 190px;
    overflow-y: auto;
}
.nearby-panel-body::-webkit-scrollbar {
    width: 6px;
}
.nearby-panel-body::-webkit-scrollbar-thumb {
    background: #c7d2fe;
    border-radius: 6px;
}
.nearby-panel-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    border-top: 1px solid #eef2f7;
    font-size: 13px;
    color: #334155;
}
.nearby-panel-row em {
    font-style: normal;
}
.nearby-panel-row span {
    color: #2563eb;
    font-weight: 600;
}
.sub-title {
    font-weight: 700;
    margin: 4px 0 10px;
    color: #303133;
}
.sub-ico {
    margin-right: 6px;
}
.famous-head {
    flex-wrap: wrap;
}
.famous-name {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.school-tag,
.product-tag {
    border-radius: 4px;
    font-size: 11px;
    padding: 2px 6px;
}
.tag-city { background: #dbeafe; color: #2563eb; }
.tag-district { background: #fee2e2; color: #dc2626; }
.tag-school { background: #eef2ff; color: #4f46e5; }
.tag-prod-blue { background: #dbeafe; color: #2563eb; }
.tag-prod-cyan { background: #cffafe; color: #0e7490; }
.tag-prod-green { background: #dcfce7; color: #15803d; }
.empty-text,
.preview-footer {
    text-align: center;
    color: #909399;
    padding: 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/widgets/HighValueInsightPreview.vue